import {Paper, styled} from '@mui/material';
import {reverse} from 'named-urls';
import React, {useContext, useEffect, useMemo, useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import Notes from '../../../../components/Notes';
import {ServiceContext} from '../../../../components/Services';
import Switched from '../../../../components/Switched';
import Switcher from '../../../../components/Switcher';
import routes from '../../../../routes';
import AccountForms from './AccountForms';
import Locations from './Locations';
import People from './People';

const Container = styled(Paper)(({theme}) => ({
  '&.MuiPaper-root': {
    overflow: 'hidden',
    marginTop: theme.spacing(1),
  }
}));

const Tabs = ({contact, onContactUpdated}) => {
  const services = useContext(ServiceContext);
  const match = useRouteMatch();
  const [tab, setTab] = useState('loading');

  const tabs = useMemo(() => [
    {
      title: 'Locations',
      slug: '',
      path: reverse(contact.archived ? routes.archive.contact.detail : routes.contacts.detail, {
        id: contact?.id ?? 0,
      })
    },
    {
      title: 'People',
      slug: 'people',
      path: reverse(contact.archived ? routes.archive.contact.tab : routes.contacts.tab, {
        id: contact?.id ?? 0,
        tab: 'people'
      })
    },
    {
      title: 'Notes',
      slug: 'notes',
      path: reverse(contact.archived ? routes.archive.contact.tab : routes.contacts.tab, {
        id: contact?.id ?? 0,
        tab: 'notes'
      })
    },
    {
      title: 'Account Forms',
      slug: 'account-forms',
      path: reverse(contact.archived ? routes.archive.contact.tab : routes.contacts.tab, {
        id: contact?.id ?? 0,
        tab: 'account-forms'
      })
    }
  ], [contact]);

  useEffect(() => {
    if (match.params?.tab && tabs.findIndex(t => t.slug) >= 0) {
      setTab(match.params?.tab);
    } else {
      setTab('');
    }
  }, [match, tabs]);

  return (
    <>
      <Switcher tabs={tabs}/>
      <Container>
        <Switched tab="" currentTab={tab}>
          <Locations contact={contact} onContactUpdated={onContactUpdated}/>
        </Switched>
        <Switched tab="people" currentTab={tab}>
          <People contact={contact} onContactUpdated={onContactUpdated}/>
        </Switched>
        <Switched tab="notes" currentTab={tab}>
          <Notes
            entity={contact}
            onEntityUpdated={onContactUpdated}
            type="contact"
            onSave={({comment}) => services.contact.note.saveNote(contact, {comment})}
          />
        </Switched>
        <Switched tab="account-forms" currentTab={tab}>
          <AccountForms contact={contact} onContactUpdated={onContactUpdated}/>
        </Switched>
      </Container>
    </>
  );
};

export default Tabs;
